import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import { DataTableColumn } from '../data-table';

export type ColumnsControlProps = {
  columns: DataTableColumn[];
  visibleFields: { field: string; width?: number }[];
  categories?: string[];
  showAllCategories: boolean;
  setShowAllCategories: Dispatch<SetStateAction<boolean>>;
  handleColumnChange: (e: any, column: DataTableColumn) => any;
};

export const ColumnsControl: FC<ColumnsControlProps> = ({
  columns,
  visibleFields,
  categories,
  showAllCategories,
  setShowAllCategories,
  handleColumnChange
}) => {
  const hasCategories = useMemo(
    () => !!categories && categories.filter(category => category.toUpperCase() !== 'COMMON').length > 0,
    [categories]
  );

  return (
    <>
      <div className="d-flex justify-content-between text-uppercase">
        <h4>Columns</h4>
      </div>
      <div className="grid-4 mb-4">
        <div className="">
          {hasCategories && <p className="text-info-main mb-2">Common</p>}
          <div className="d-flex flex-column">
            {columns
              .filter(column => !column.category || column.category?.toUpperCase() === 'COMMON')
              .map((column, index) => (
                <div
                  className="d-flex flex-row align-items-center white-space-nowrap g-2"
                  id={`common-${index}`}
                  key={`common-${index}`}
                >
                  <input
                    type="checkbox"
                    checked={visibleFields.find(f => f.field === column.field) !== undefined}
                    onChange={e => handleColumnChange(e, column)}
                  />
                  <span className="text-info-main">{column.label}</span>
                </div>
              ))}
          </div>
        </div>
        {showAllCategories && !!categories && (
          <>
            {categories
              .filter(category => category.toUpperCase() !== 'COMMON')
              .map((category, idx) => (
                <div className="" id={`category-${idx}`} key={`category-${idx}`}>
                  <p className="text-info-main mb-2">{category}</p>
                  <div className="d-flex flex-column">
                    {columns
                      .filter(column => !!column.category && column.category.toUpperCase() === category.toUpperCase())
                      .map((column, index) => (
                        <div
                          className="d-flex flex-row align-items-center white-space-nowrap g-2"
                          id={`common-${index}`}
                          key={`common-${index}`}
                        >
                          <input
                            type="checkbox"
                            checked={visibleFields.find(f => f.field === column.field) !== undefined}
                            onChange={e => handleColumnChange(e, column)}
                          />
                          <span className="text-uppercase text-info-main">{column.label}</span>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
          </>
        )}
      </div>
      {hasCategories && (
        <div className="d-flex flex-row-reverse">
          <button className="btn-outline text-uppercase" onClick={() => setShowAllCategories(!showAllCategories)}>
            {showAllCategories ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}
    </>
  );
};
